<script setup>
import { defineEmits, defineProps } from 'vue'

const emits = defineEmits(['onClick'])

defineProps({
  avatarUrl: { type: String, default: null },
  fullname: {type: String, default: ''},
  both: {type: Boolean, default: false},
  online: {type: Boolean, default: false}
})

function getInitial(name) {
  let initialName = ''
  if(name) {
    const [firstname, lastname] = name.toUpperCase().split(' ')
    initialName += firstname[0]
    if(lastname) {
      initialName += lastname[0]
    }
  }

  return initialName
}

function onClick() {
  emits('onClick')
}


</script>

<template>
  <div @click.prevent="onClick()" :class="{'border border-2 border-primary': online}" class="symbol symbol-circle symbol-30px">
    <img v-if="avatarUrl" :src="avatarUrl" :alt="fullname" />
    <div v-if="both || !avatarUrl" class="symbol-label fs-5 fw-semibold bg-inverse-primary text-primary">{{ getInitial(fullname) }}</div>
  </div>
</template>

<style scoped>

</style>
